<div class="screen-fit" [formGroup]="patientForm">

    <app-title-header [title]="_title" [subtitle]="_subtitle" class="d-xl-block d-none"></app-title-header>
    <app-steps-doctor class="steps-doctor" [steps]="steps" [showSuccessMessage]="showSuccessMessage"></app-steps-doctor>

    <div class="row mt-xl-3 mx-0 h-100">
        <div class="col-12 p-0 left-col-fill" *ngIf="showSuccessMessage">
            <div class="card h-100 p-0 card-left form-card d-flex align-items-center justify-content-center">
                <div class="text-center p-4">

                    <!-- Icono -->
                    <div class="mb-3">
                        <i class="fa fa-check-circle" style="font-size:48px;color:#0B197A;"></i>
                    </div>

                    <!-- Título -->
                    <h5 class="mb-2" style="color:#0B197A;font-weight:700;">
                        ¡La reserva de hora ha sido realizada con éxito!
                    </h5>

                    <!-- Texto email -->
                    <p class="mb-4" style="color:#7A7A7A;">
                        El paciente recibirá en su correo los detalles para confirmar su asistencia.
                    </p>

                    <!-- Botones -->
                    <div class="d-flex flex-column flex-sm-row justify-content-center">
                        <button type="button" class="btn btn-secondary btn-pill mb-2 mb-sm-0 mr-sm-3"
                            (click)="onNewAppointment()">
                            Agendar otro paciente
                        </button>

                        <button type="button" class="btn btn-secondary btn-pill" (click)="goToDashboard()">
                            Volver al Inicio
                        </button>
                    </div>

                </div>
            </div>
        </div>
        <!-- ====================== STEP 1 ====================== -->
        <div class="col-xl-8 col-12 p-0 left-col-fill" *ngIf="steps.searchPatient">
            <div class="card h-100 p-0 card-left form-card">

                <div class="form-step-header px-4 pt-3 pb-0 d-flex align-items-center" style="gap: 15px;">
                    <div class="step d-flex flex-column align-items-center">
                        <div class="step-icon">
                            <i class="fi fi-rr-search mr-2 icon-step"></i>
                        </div>

                    </div>
                    <div>
                        <div class="text-uppercase text-muted small mb-1">Paso 1</div>
                        <h5 class="m-0 title-step">Completa los datos</h5>
                    </div>
                </div>

                <div class="form-content px-4 py-3">
                    <label class="title-step"></label>
                    <h5 class="title-step">Busca por RUT/DNI</h5>

                    <div class="input-group mb-4 autocomplete-container position-relative"
                        (click)="$event.stopPropagation()">
                        <input type="text"
    class="form-control form-control-rounded"
    placeholder="Busca por RUT/DNI"
    [formControl]="searchCtrl"
    (focus)="showDropdown = true"
    (keydown.enter)="onEnterSearch()"
    (keypress)="allowOnlyRutChars($event)"
    (paste)="onRutPaste($event)"
    (input)="onRutSearchInput($event.target.value)"
    [ngClass]="{'is-invalid': searchRutInvalid}"
    autocomplete="off" />


                        <div class="dropdown-menu w-100 mt-1 show" *ngIf="showDropdown"
    style="max-height: 320px; overflow:auto;">

    <button class="dropdown-item disabled" *ngIf="loading">
        Buscando…
    </button>

    <ng-container *ngIf="!loading">

        <div class="dropdown-item disabled text-danger" *ngIf="searchRutInvalid">
            El RUT ingresado no es válido.
        </div>

        <div class="dropdown-item disabled" *ngIf="!searchRutInvalid && resultados.length === 0">
            Paciente no encontrado
        </div>

        <button type="button"
            class="dropdown-item font-weight-bold"
            *ngIf="puedeMostrarAgregarRutBuscado()"
            (click)="prepararNuevoUsuario()">
            + Agregar usuario con RUT {{ (searchCtrl.value || '') | uppercase }}
        </button>

        <div class="dropdown-divider" *ngIf="puedeMostrarAgregarRutBuscado() && resultados.length > 0"></div>

        <button type="button"
            class="dropdown-item d-flex align-items-center"
            *ngFor="let p of resultados"
            (click)="seleccionarUsuario(p)">

            <i class="fi fi-rr-user mr-2"></i>

            <div class="d-flex flex-column text-left">
                <strong>{{ p.use_name }} {{ p.use_paternal_surname }}</strong>
                <small class="text-muted">{{ p.use_username || p.use_rut }}</small>
            </div>
        </button>

    </ng-container>
</div>
                    </div>
                    <h5 class=" title-step">Completa los datos del paciente</h5>

                    <div class="form-row">
                        <div class="form-group col-lg-12 col-xl-6">
                            <label class="label-sm">RUT*</label>
                            <input type="text" class="form-control form-control-rounded" placeholder="RUT"
                                formControlName="use_rut" [readonly]="true" (keypress)="allowOnlyRutChars($event)" />
                        </div>

                        <div class="form-group col-lg-12 col-xl-6">
                            <label class="label-sm">Nombre*</label>
                            <input type="text" class="form-control form-control-rounded" placeholder="Nombre"
                                formControlName="use_name" (keypress)="allowOnlyLetters($event)"
                                [readonly]="!step1Unlocked" />
                        </div>

                        <div class="form-group col-lg-12 col-xl-6">
                            <label class="label-sm">Apellido Paterno*</label>
                            <input type="text" class="form-control form-control-rounded" placeholder="Apellido Paterno"
                                formControlName="paterno" (keypress)="allowOnlyLetters($event)"
                                [readonly]="!step1Unlocked" />
                        </div>

                        <div class="form-group col-lg-12 col-xl-6">
                            <label class="label-sm">Apellido Materno</label>
                            <input type="text" class="form-control form-control-rounded" placeholder="Apellido Materno"
                                formControlName="materno" (keypress)="allowOnlyLetters($event)"
                                [readonly]="!step1Unlocked" />
                        </div>

                        <div class="form-group col-lg-12 col-xl-6">
                            <label class="label-sm">Fecha de nacimiento*</label>
                            <input type="date" class="form-control form-control-rounded" formControlName="nacimiento"
                                [disabled]="!step1Unlocked" />
                        </div>

                        <div class="form-group col-lg-12 col-xl-6">
                            <div class="form-row no-gutters">

                                <div class="col-4 col-md-4 pr-2">
                                    <label class="label-sm">Código de Área</label>

                                    <div class="custom-select-flag" (click)="step1Unlocked && toggleFlagDropdown()"
                                        [class.open]="flagDropdownOpen" [class.disabled]="!step1Unlocked">

                                        <!-- Valor seleccionado -->
                                        <div class="selected d-flex align-items-center justify-content-between">
                                            <div class="d-flex align-items-center">
                                                <span class="fi mr-2" [ngClass]="selectedAreaCode?.cou_flag"
                                                    style="font-size: 10px;"></span>
                                                (+{{ selectedAreaCode?.cou_phone_code }})
                                            </div>
                                            <i class="fi fi-rr-angle-small-down"></i>
                                        </div>

                                        <!-- Dropdown -->
                                        <div class="options" *ngIf="flagDropdownOpen">
                                            <div class="option" *ngFor="let areaCode of areaCodes"
                                                (click)="step1Unlocked && selectAreaCode(areaCode)">
                                                <span class="fi mr-2" [ngClass]="areaCode.cou_flag"></span>
                                                (+{{ areaCode.cou_phone_code }})
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col col-md-8">
                                    <label class="label-sm">Teléfono*</label>
                                    <input type="tel" class="form-control form-control-rounded" placeholder="Teléfono"
                                        formControlName="telefono" (keypress)="allowOnlyNumbers($event)"
                                        [attr.minlength]="selectedAreaCode?.cou_min_phone"
                                        [attr.maxlength]="selectedAreaCode?.cou_max_phone"
                                        maxlength="{{selectedAreaCode?.cou_max_phone || 15}}"
                                        [readonly]="!step1Unlocked" />

                                    <small class="text-muted d-block m-0" *ngIf="selectedAreaCode">
                                        Ingrese número entre {{selectedAreaCode?.cou_min_phone}} y
                                        {{selectedAreaCode?.cou_max_phone}} dígitos.
                                    </small>
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-12">
                            <label class="label-sm">Correo electrónico*</label>
                            <input type="email" class="form-control form-control-rounded"
                                placeholder="Correo electrónico" formControlName="email" [readonly]="!step1Unlocked">
                        </div>

                        <div class="form-footer col-12">
                            <div class="d-flex justify-content-center">
                                <button type="button" class="btn btn-secondary btn-pill" [disabled]="!isStep1Valid()"
                                    (click)="nextFromStep1()">
                                    Siguiente
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!-- ====================== STEP 2 ====================== -->
        <div class="col-xl-8 col-12 p-0 left-col-fill" *ngIf="steps.selectDate">
            <div class="card h-100 p-0 card-left form-card">

                <div class="form-step-header px-4 pt-3 pb-0 d-flex align-items-center" style="gap: 15px;">
                    <div class="step d-flex flex-column align-items-center">
                        <div class="step-icon">
                            <i class="fi fi-rr-calendar mr-2 icon-step"></i>
                        </div>

                    </div>
                    <div>
                        <div class="text-uppercase text-muted small mb-1">Paso 2</div>
                        <h5 class="m-0 title-step">Elige fecha y hora</h5>
                    </div>
                </div>

                <div class="form-content px-4 py-3">
                    <div class="form-row">
                        <div class="form-group col-12">
                            <app-schedule-picker *ngIf="infoDoctor?.doc_id" [docId]="infoDoctor.doc_id"
                                [initialDate]="patientForm.value.sch_date"
                                [initialHourId]="patientForm.value.sch_hou_id" (dateSelected)="onDateSelected($event)"
                                (slotSelected)="onSlotSelected($event)">
                            </app-schedule-picker>


                        </div>

                        <div class="form-footer col-12">
                            <div class="d-flex justify-content-center">
                                <button type="button" class="btn btn-light btn-pill mr-2"
                                    (click)="volverStep1()">Volver</button>
                                <button type="button" class="btn btn-secondary btn-pill"
                                    [disabled]="!canProceedFromStep2()" (click)="nextFromStep2()">
                                    Siguiente
                                </button>
                            </div>
                            <!-- <small class="text-muted d-block mt-2">
                                Fecha: {{ patientForm.value.sch_date || '—' }} |
                                Hora: {{ patientForm.value.sch_from || '—' }} - {{ patientForm.value.sch_to || '—' }}
                            </small> -->
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <!-- ====================== STEP 3 ====================== -->
        <div class="col-xl-8 col-12 p-0 left-col-fill" *ngIf="steps.payment">
            <div class="card h-100 p-0 card-left form-card">

                <div class="form-step-header px-4 pt-3 pb-0 d-flex align-items-center" style="gap: 15px;">
                    <div class="step d-flex flex-column align-items-center">
                        <div class="step-icon">
                            <i class="fi fi-rr-credit-card mr-2 icon-step"></i>
                        </div>

                    </div>
                    <div>
                        <div class="text-uppercase text-muted small mb-1">Paso 3</div>
                        <h5 class="m-0 title-step">Motivo y tarifa</h5>
                    </div>
                </div>

                <div class="form-content px-4 py-3">
                    <div class="form-row">

                        <div class="form-group col-lg-12 col-xl-6">
                            <label class="label-sm" style="">Área médica</label>
                            <select class="form-control form-control-rounded" formControlName="area_medica"
                                style="display: flex; align-items: center; flex-direction: row;">
                                <option [ngValue]="null" disabled>Selecciona un área</option>
                                <option *ngFor="let a of areasMedicas" [ngValue]="a">{{ a.nombre }}</option>
                            </select>
                        </div>

                        <div class="form-group col-lg-12 col-xl-6">
                            <label class="label-sm">Acompañante</label>
                            <select class="form-control form-control-rounded"
        formControlName="acompaniante"
        style="display: flex; align-items: center; flex-direction: row;">

  <option [ngValue]="null">
    {{ loadingAcompanantes ? 'Cargando acompañantes...' : 'Selecciona un acompañante' }}
  </option>

  <option *ngFor="let a of acompanantesPaciente" [ngValue]="a">
    {{ a.use_name || a.nombre || '' }}
    {{ a.use_paternal_surname || a.apellido_paterno || '' }}
    {{ a.use_maternal_surname || a.apellido_materno || '' }}
  </option>
</select>

<small class="text-muted d-block mt-1" *ngIf="!loadingAcompanantes && acompanantesPaciente.length === 0">
  El paciente seleccionado no tiene acompañantes registrados.
</small>
                        </div>

                        <div class="form-group col-12">
                            <label class="label-sm">Motivo de consulta / síntomas</label>
                            <textarea class="form-control form-control-rounded" style="min-height:120px"
                                formControlName="motivo"></textarea>
                        </div>
                        <!-- Adjuntos opcionales -->
                        <div class="form-group col-12">

                            <!-- Botón que abre el modal -->
                            <button type="button" class="btn btn-pill mb-2" (click)="openDocumentoModal()" style="border-radius: revert; height: fit-content;
                                            font-size: 12px;
                                            padding: 10px;
                                            border-radius: 12px;
                                            border: solid 1px #0B197A;
                                            color: #0B197A;background: white;">
                                <i class="fi fi-rr-upload"></i> Subir documento
                            </button>

                            <!-- Listado de documentos ya agregados -->
                            <div *ngIf="selectedFiles?.length" class="mt-2">
                                <div *ngFor="let f of selectedFiles; let idx = index"
                                    class="d-flex align-items-center mb-1">
                                    <i class="fi fi-rr-assept-document"></i> <small class="text-truncate"
                                        style="max-width:280px" [title]="f.finalName || f.file?.name">
                                        {{ f.finalName || f.file?.name }}
                                    </small>
                                    <button type="button" class="btn btn-link btn-sm ml-2 p-0"
                                        (click)="removeFile(idx)">
                                        Quitar
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="form-group col-12">
                            <label class="label-sm">Tarifa</label>
                            <select class="form-control form-control-rounded" formControlName="tarifa"
                                style="display: flex; align-items: center; flex-direction: row;">

                                <option [ngValue]="null" disabled>Selecciona una tarifa</option>

                                <option *ngFor="let t of tarifas" [ngValue]="t">
                                    <ng-container *ngIf="t.tipo !== 'custom'; else customTpl">
                                        {{ t.label }} — {{ t.monto | currency:'CLP':'symbol':'1.0-0':'es-CL' }}
                                    </ng-container>

                                    <ng-template #customTpl>
                                        {{ t.label }}
                                    </ng-template>
                                </option>

                            </select>

                            <div class="mt-2" *ngIf="patientForm.value.tarifa?.tipo === 'custom'">
                                <label class="label-sm mb-1">Monto personalizado</label>

                                <input type="text" class="form-control form-control-rounded"
                                    formControlName="tarifa_custom_monto" placeholder="Ej: $15.000"
                                    (input)="onTarifaCustomInput($event)" (keypress)="allowOnlyNumbers($event)" />

                                <small class="text-danger"
                                    *ngIf="patientForm.get('tarifa_custom_monto')?.touched && patientForm.get('tarifa_custom_monto')?.invalid">
                                    Ingresa un monto válido entre $0 y $1.000.000.
                                </small>
                            </div>

                            <!-- <small class="text-muted d-block mt-1" *ngIf="!tarifas?.length">
                                Este profesional no tiene una tarifa configurada para la especialidad seleccionada.
                            </small> -->
                        </div>
                        <div class="form-footer col-12">
                            <div class="d-flex justify-content-center">
                                <button type="button" class="btn btn-light btn-pill mr-2"
                                    (click)="volverStep2()">Volver</button>
                                <button type="button" class="btn btn-secondary btn-pill"
                                    [disabled]="!canProceedFromStep3()" (click)="nextFromStep3()">
                                    Siguiente
                                </button>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>

        <!-- ====================== STEP 4 (RESUMEN) ====================== -->
        <div class="col-12 p-0 left-col-fill" *ngIf="steps.showSummary && !showSuccessMessage">
            <div class="card h-100 p-0 card-left form-card">

                <div class="form-step-header px-4 pt-3 pb-0 d-flex align-items-center" style="gap: 15px;">
                    <div class="step d-flex flex-column align-items-center">
                        <div class="step-icon">
                            <i class="fi fi-rr-envelope mr-2 icon-step"></i>
                        </div>

                    </div>
                    <div>
                        <div class="text-uppercase text-muted small mb-1">Paso 4</div>
                        <h5 class="m-0 title-step">Revisa y confirma</h5>
                    </div>
                </div>

                <div class="form-content px-4 py-3">
                    <div class="row">
                        <div class="col-12 contenedor-cards">

                            <div class="card-resumen">
                                <p class="m-0" style="color:#0B197A;font-size:16px;font-weight:700;">
                                    {{ patientForm.value.use_name || '' }} {{ patientForm.value.paterno || '' }} {{
                                    patientForm.value.materno || '' }}
                                </p>
                                <p class="m-0"><i class="fi fi-rr-user"></i> {{ patientForm.value.use_rut || '—' }}</p>
                                <p class="m-0"><i class="fi fi-rr-envelope"></i> {{ patientForm.value.email || '—' }}
                                </p>
                                <p class="m-0"><i class="fi fi-rr-phone-call"></i> (+{{ patientForm.value.telefonoCodigo
                                    || '—'
                                    }}) {{ patientForm.value.telefono || '' }}</p>
                            </div>
                            <div class="card-resumen"
                                style="display: flex; flex-direction: column; justify-content: center;">
                                <span style="color: #0B197A;
    font-size: 16px;
    font-weight: 700;">Fecha y hora de la consulta</span>
                                <p class="m-0"><i class="fi fi-rr-calendar"></i><strong> Fecha:</strong> {{
                                    patientForm.value.sch_date | date:'dd-MM-yyyy' }}</p>
                                <p class="m-0"><i class="fi fi-rr-time-check"></i><strong> Hora:</strong> {{
                                    patientForm.value.sch_from || '—' }} - {{
                                    patientForm.value.sch_to || '—' }}</p>
                            </div>
                        </div>
                        <div class="col-12 contenedor-cards">

                            <div class="card-resumen row" style="margin: inherit;">
                                <div class="col-xl-6 col-12">
                                    <span style="color: #0B197A;
    font-size: 16px;
    font-weight: 700;">Área médica</span>
                                    <p>{{ patientForm.value.area_medica?.nombre || '—' }}</p>
                                </div>
                                <div class="col-xl-6 col-12">
                                    <span style="color: #0B197A;
    font-size: 16px;
    font-weight: 700;">Acompañante</span>
                                    <p>{{ patientForm.value.acompaniante?.nombre || '—' }}</p>
                                </div>
                                <br>
                                <hr>
                                <div class="col-12">
                                    <span style="color: #0B197A;
    font-size: 16px;
    font-weight: 700;">Motivo</span>
                                    <p>{{ patientForm.value.motivo || '—' }}</p>
                                </div>
                                <br>
                                <hr>
                                <div class="col-12">
                                    <span style="color: #0B197A;
    font-size: 16px;
    font-weight: 700;">Documentos adjuntos</span>

                                    <!-- Si hay documento con nombre custom -->
                                    <ng-container *ngIf="documentoNombreResumen; else sinDocumentos">
                                        <p>{{ documentoNombreResumen }}</p>
                                    </ng-container>

                                    <!-- Si no hay documentos -->
                                    <ng-template #sinDocumentos>
                                        <p>—</p>
                                    </ng-template>
                                </div>

                                <br>
                                <hr>
                                <div class="col-12">
    <span style="color: #0B197A;
        font-size: 16px;
        font-weight: 700;">Tarifa</span>

    <p *ngIf="patientForm.value.tarifa?.tipo !== 'custom'">
        {{ patientForm.value.tarifa?.monto | currency:'CLP':'symbol':'1.0-0':'es-CL' }}
    </p>

    <p *ngIf="patientForm.value.tarifa?.tipo === 'custom'">
        {{ patientForm.value.tarifa_custom_monto || '$0' }}
    </p>
</div>
                            </div>
                        </div>

                        <div class="col-12 mt-3">
                            <div class="d-flex justify-content-center">
                                <button type="button" class="btn btn-light btn-pill mr-2"
                                    (click)="volverStep3()">Volver</button>
                                <button type="button" class="btn btn-secondary btn-pill"
                                    (click)="onConfirmAppointment()" [disabled]="loadingSubmit">

                                    <span *ngIf="loadingSubmit" class="spinner-border spinner-border-sm mr-2"
                                        role="status" aria-hidden="true"></span>
                                    {{ loadingSubmit ? 'Procesando...' : 'Continuar' }}
                                </button>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <!-- Columna lateral: mini-resumen en vivo -->
        <div class="col-xl-4 d-none d-xl-block pl-xl-2 pr-0" *ngIf="!steps.showSummary && !showSuccessMessage">
            <div class="card h-100 p-4" style="display:flex;justify-content:start; padding-top: 36px !important;">
                <div class="mb-2 d-flex flex-row justify-content-center">
                    <i class="d-flex fi fi-rr-calendar" style="color:#0B197A;align-items:center;"></i>
                    <h6 class="m-0"
                        style="font-family: 'Mulish'; line-height: normal; font-size: 16px; color:#0B197A;font-weight:700;line-height:1.2;letter-spacing:.2px;">
                        Resumen del agendamiento</h6>
                </div>
                <p class="text-muted" *ngIf="steps.searchPatient" style="text-align: center; ">Completa los datos del
                    formulario</p>
                <div class="not-hours" *ngIf="steps.searchPatient">
                    <div class="d-flex">
                        <i class="d-flex fi fi-rr-info" style="align-items:center;"></i>
                        <span style="color: #0B197A;
    font-size: 14px;
    font-weight: 600;">Asegúrate que todos los datos sean correctos.</span>
                    </div>
                </div>

                <div *ngIf="steps.selectDate || steps.payment || steps.showSummary">
                    <div class="card-resumen" *ngIf="steps.selectDate || steps.payment">
                        <p class="m-0" style="color:#0B197A;font-size:16px;font-weight:700;">
                            {{ patientForm.value.use_name || '' }} {{ patientForm.value.paterno || '' }} {{
                            patientForm.value.materno || '' }}
                        </p>
                        <p class="m-0"><i class="fi fi-rr-user"></i> {{ patientForm.value.use_rut || '—' }}</p>
                        <p class="m-0"><i class="fi fi-rr-envelope"></i> {{ patientForm.value.email || '—' }}</p>
                        <p class="m-0"><i class="fi fi-rr-phone-call"></i> (+{{ patientForm.value.telefonoCodigo || '—'
                            }}) {{ patientForm.value.telefono || '' }}</p>
                    </div>
                    <div class="card-resumen" *ngIf="steps.payment">
                        <p class="m-0" style="color:#0B197A;font-size:16px;font-weight:700;">Fecha y hora de consulta
                        </p>
                        <p class="m-0"><i class="fi fi-rr-calendar"></i> Fecha: {{ patientForm.value.sch_date |
                            date:'dd-MM-yyyy' }}</p>
                        <p class="m-0"><i class="fi fi-rr-time-check"></i> Hora: {{ patientForm.value.sch_from || '—' }}
                            - {{
                            patientForm.value.sch_to || '—' }}</p>
                    </div>

                </div>


            </div>
        </div>

        <div class="col-12 p-0 left-col-fill" *ngIf="showSuccessMessage">
            <div class="card h-100 p-0 card-left form-card">
            </div>
        </div>

    </div>
</div>

<!-- Modal para nombre + archivo -->
<div class="modal fade show d-block" tabindex="-1" role="dialog" style="background: rgba(0,0,0,.5);"
    *ngIf="showDocumentoModal">
    <div class="modal-dialog" role="document">
        <div class="modal-content">

            <div class="modal-header">
                <h5 class="modal-title">Adjuntar documento</h5>
                <button type="button" class="close" (click)="closeDocumentoModal()">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body" [formGroup]="modalDocForm">
                <div class="form-group">
                    <label class="label-sm">Nombre del documento</label>
                    <input type="text" class="form-control form-control-rounded" formControlName="displayName"
                        placeholder="Ej: Exámenes previos, Epicrisis, etc.">
                </div>

                <div class="form-group">
                    <label class="label-sm">Archivo</label>
                    <input type="file" class="form-control-file" (change)="onModalFileSelected($event)"
                        accept=".pdf,.jpg,.jpeg,.png,.heic,.heif,.webp">
                    <small class="text-muted d-block mt-1" *ngIf="modalFileNamePreview">
                        Archivo seleccionado: {{ modalFileNamePreview }}
                    </small>
                </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btn-light btn-pill" (click)="closeDocumentoModal()">
                    Cancelar
                </button>
                <button type="button" class="btn btn-secondary btn-pill" (click)="confirmarDocumento()">
                    Aceptar
                </button>
            </div>

        </div>
    </div>
</div>